import { call, put, takeLatest } from "redux-saga/effects";
import { getType } from "typesafe-actions";
import { userLoggedIn, userLoginFail } from "../../../../../common/actions/auth.actions";
import { GroupToken, storageAuthInformation, storageRoles } from "../../../../../common/constants/strings";
import { AuthDto } from "../../../../../common/dtos/auth.dtos";
import { TokenDto } from "../../../../account/login/login.dtos";
import { groupLoginActions } from "./login.actions";
import { groupLoginApi } from "./login.api";

function* handleLoginGroupVisit(request: ReturnType<typeof groupLoginActions.request>) {
    const token: TokenDto = yield call(groupLoginApi, request.payload);

    if (token.authToken && token.authToken.length > 0) {
      const auth: AuthDto = {
        authToken: token.authToken,
        isAdmin: false,
        isAuthenticated: true,
        refreshToken: token.refreshToken,
        roles: token.roles,
        fullName: token.fullName,
        userId: token.userId
      }
    
    sessionStorage.setItem(GroupToken, token.authToken);
    sessionStorage.setItem(storageRoles, JSON.stringify(token.roles));
    sessionStorage.setItem(storageAuthInformation, JSON.stringify(token));
    
    yield put({ type: getType(userLoggedIn), payload: auth });

    return token;
    } else {
      put({ type: getType(userLoginFail), payload: "Unauthorized" });
    }
}

  
export function* watchLoginGroupVisitRequest() {
    try {
      yield takeLatest(getType(groupLoginActions.request), handleLoginGroupVisit);
    }
    catch (err) {
      console.log(err);
    }
}